import { useCallback } from 'react';
import { mfaApi, } from '@digiwedge/idp-client';
import { useAsyncOperation } from './utils/index.js';
// 1) Hook for `POST /mfa/sms/register`
export const useRegisterSmsMfa = () => {
    const { execute: registerSmsMfaRequest, loading, error, } = useAsyncOperation(async (dto) => {
        await mfaApi.mfaControllerRegisterSmsMfa(dto);
    });
    // Optionally wrap the call in a nicer function name
    const registerSmsMfa = useCallback(async (dto) => {
        return registerSmsMfaRequest(dto);
    }, [registerSmsMfaRequest]);
    return { registerSmsMfa, loading, error };
};
// 2) Hook for `POST /mfa/sms/initiate`
export const useInitiateSmsMfa = () => {
    const { execute: initiateSmsMfaRequest, loading, error, } = useAsyncOperation(async (dto) => {
        await mfaApi.mfaControllerInitiateSmsMfa(dto);
    });
    const initiateSmsMfa = useCallback(async (dto) => {
        return initiateSmsMfaRequest(dto);
    }, [initiateSmsMfaRequest]);
    return { initiateSmsMfa, loading, error };
};
// 3) Hook for `POST /mfa/sms/verify`
export const useVerifySmsMfa = () => {
    const { execute: verifySmsMfaRequest, loading, error, } = useAsyncOperation(async (dto) => {
        await mfaApi.mfaControllerVerifySmsMfa(dto);
    });
    const verifySmsMfa = useCallback(async (dto) => {
        return verifySmsMfaRequest(dto);
    }, [verifySmsMfaRequest]);
    return { verifySmsMfa, loading, error };
};
//# sourceMappingURL=hooks-mfa.js.map